export default __webpack_public_path__ + "static/media/google-drive.550a2ecc.png";